import { RgDefaults as d, RgCreate as f, clone as h, rgSerialise as z, RvDataListSets as R, RgDataSetID as w } from "@project-rouge/rg-core";
import { MeshBasicMaterial as y } from "three";
import { resizeBasedOnChildren as D } from "../../3d/resize/index.js";
import { transformChildrenToParentSize as S } from "../../3d/resize/index2.js";
import { updateViewAnchor as C } from "../../3d/resize/index3.js";
import { RgView as M } from "../../3d/rg-render-types/index4.js";
import { dispose as V } from "../../utils/three/index.js";
const $ = new y(), o = {};
function L({ rgObj: e, rvData: t = R[w.uk_01], useCache: c = !0 }) {
  const n = s(e), a = { ...e };
  if (c && o[n])
    e = o[n];
  else {
    const r = e.size.slice(), m = e.anchor.slice(), l = e.type, p = e.name, u = d[l];
    e = f({ ...h(u) }, t), e.name = p;
    const i = new M(z(e), $);
    D(i), e.size = r, S(i, e), C(i, m, !0), V(i), o[n] = e;
  }
  return e = Object.assign({}, a, { children: e.children, uuid: e.uuid }), e;
}
function s(e) {
  let t = `${e.type}/${e.size.join("|")}/${e.anchor.join("|")}`;
  return t += e.children.map(s).join("|"), t;
}
export {
  L as ResizeRgObj
};
//# sourceMappingURL=index22.js.map
